// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadToDtaRequestFilesInner } from './upload-to-dta-request-files-inner';
import {
    UploadToDtaRequestFilesInnerFromJSON,
    UploadToDtaRequestFilesInnerFromJSONTyped,
    UploadToDtaRequestFilesInnerToJSON,
    UploadToDtaRequestFilesInnerToJSONTyped,
} from './upload-to-dta-request-files-inner';

/**
 * 
 * @export
 * @interface UploadToDtaRequest
 */
export interface UploadToDtaRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UploadToDtaRequest
     */
    dryRun: boolean;
    /**
     * 
     * @type {string}
     * @memberof UploadToDtaRequest
     */
    dtaVersion: string;
    /**
     * 
     * @type {Array<UploadToDtaRequestFilesInner>}
     * @memberof UploadToDtaRequest
     */
    files: Array<UploadToDtaRequestFilesInner>;
}

/**
 * Check if a given object implements the UploadToDtaRequest interface.
 */
export function instanceOfUploadToDtaRequest(value: object): value is UploadToDtaRequest {
    if (!('dryRun' in value) || value['dryRun'] === undefined) return false;
    if (!('dtaVersion' in value) || value['dtaVersion'] === undefined) return false;
    if (!('files' in value) || value['files'] === undefined) return false;
    return true;
}

export function UploadToDtaRequestFromJSON(json: any): UploadToDtaRequest {
    return UploadToDtaRequestFromJSONTyped(json, false);
}

export function UploadToDtaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadToDtaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dryRun': json['dryRun'],
        'dtaVersion': json['dtaVersion'],
        'files': ((json['files'] as Array<any>).map(UploadToDtaRequestFilesInnerFromJSON)),
    };
}

export function UploadToDtaRequestToJSON(json: any): UploadToDtaRequest {
    return UploadToDtaRequestToJSONTyped(json, false);
}

export function UploadToDtaRequestToJSONTyped(value?: UploadToDtaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dryRun': value['dryRun'],
        'dtaVersion': value['dtaVersion'],
        'files': ((value['files'] as Array<any>).map(UploadToDtaRequestFilesInnerToJSON)),
    };
}
